import { Grid2 } from "@mui/material";
import FieldNoteCard from "../cards/fieldNoteCard.component";
import { useEffect, useState } from "react";
import NoteDetailDialog from "../muiDialogs/noteDetailDialog.component";
import BaseDialog from "../muiDialogs/baseDialog.component";
import { fieldNoteDialogConfig } from "../muiDialogs/config";
import NoteForm from "../forms/noteForm/noteForm.component";
import { useDispatch, useSelector } from "react-redux";
import { fetchFieldNotesStart } from "../../store/features/fieldNotes/fieldNotesSlice";
import { resetFieldNoteState } from "../../store/features/fieldNote/fieldNoteSlice";
import CustomAlert from "../alert/alert.component";
import { FIELD_NOTE_MESSAGES } from "../forms/noteForm/constants";
import FieldCardSkeleton from "../skeletons/fieldCardSkeleton.component";

const getFieldNoteMessage = (operationType) => {
  return FIELD_NOTE_MESSAGES[operationType] || "Operazione completata";
};

const FieldNoteBox = ({ fieldNotesData, isMobile, isFieldPage }) => {
  const dispatch = useDispatch();

  const [openDetailDialog, setOpenDetailDialog] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const { success, operationType } = useSelector((state) => state.fieldNote);
  const { isLoading } = useSelector((state) => state.fieldNotes);

  const handleOpenDialog = (note) => {
    setOpenDetailDialog(true);
    setSelectedNote(note);
  };
  const handleCloseDetailDialog = () => {
    setOpenDetailDialog(false);
    setOpenEditDialog(true);
  };

  useEffect(() => {
    if (success) {
      setAlertMessage(getFieldNoteMessage(operationType));
      setOpenEditDialog(false);
      dispatch(fetchFieldNotesStart({ search: "" }));
      dispatch(resetFieldNoteState());
      setShowAlert(true);
    }
  }, [dispatch, success, operationType]);

  return (
    <Grid2 container direction="row" spacing={1} sx={{ alignItems: "center" }}>
      {isLoading
        ? Array.from({ length: 2 }).map((_, index) => (
            <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={index}>
              <FieldCardSkeleton
                variant="rectangular"
                width="100%"
                height="172px"
              />
            </Grid2>
          ))
        : fieldNotesData?.map((note) => (
            <Grid2 key={note.id} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <FieldNoteCard
                title={note.title}
                note_type={note.note_type}
                description={note.description}
                date={note.created_at}
                isMobile={isMobile}
                onClick={() => handleOpenDialog(note)}
              />
            </Grid2>
          ))}
      <NoteDetailDialog
        open={openDetailDialog}
        onClose={() => setOpenDetailDialog(false)}
        note={selectedNote}
        onEdit={handleCloseDetailDialog}
      />
      <BaseDialog
        open={openEditDialog}
        config={fieldNoteDialogConfig}
        onClose={() => setOpenEditDialog(false)}
        title="Modifica nota"
        children={
          <NoteForm
            mode="edit"
            initialData={selectedNote}
            isFieldPage={isFieldPage}
            onSuccess={() => setOpenEditDialog(false)}
            isMobile={isMobile}
          />
        }
      />
      {showAlert && (
        <CustomAlert
          severity="success"
          message={alertMessage}
          onClose={() => setShowAlert(false)}
        />
      )}
    </Grid2>
  );
};

export default FieldNoteBox;
